import { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { useCreateShortUrl } from "services/urlShortener";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";

export default () => {
  const isMobile = useIsMobile();
  const [isDisabled, setIsDisabled] = useState(false);
  const [url, setUrl] = useState("");
  const [shortUrl, setShortUrl] = useState("");
  const { request } = useCreateShortUrl((r) => {
    setShortUrl(r.shortUrl);
  });
  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(event.target.value);
  };

  const onClick = async () => {
    setIsDisabled(true);
    await request({ url });
    setIsDisabled(false);
  };
  return (
    <GridPage
      sx={{
        margin: isMobile ? "" : "auto",
        maxWidth: "1000px",
        padding: isMobile ? "20px" : "64px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography variant="title" id="tableTitle">
          URL Shortener
        </Typography>
        <Box>
          <Typography>
            The URL shortener shortens long urls that contain a metadata
            information, like shopping affiliate links, and produce a concise
            Faye url. This can also replace other url shorteners when sending
            text messsages, which are often marked as spam.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
          }}
        >
          <TextField
            value={url}
            autoComplete="off"
            label="Url"
            size="small"
            fullWidth
            onChange={handleEmailChange}
          ></TextField>
          <Box>
            <Button disabled={isDisabled} onClick={onClick}>
              Generate
            </Button>
          </Box>
        </Box>
        {shortUrl && (
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <Typography>{shortUrl}</Typography>
            <Box>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  navigator.clipboard.writeText(shortUrl);
                }}
              >
                Copy
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </GridPage>
  );
};
